import React, {useState} from 'react'
import Accordion from '@/scripts/components/shared/accordion-group/accordion'

export default function DualAccordionGroup(props) {

    const {
        closeSiblings,
        columns
    } = props

    let initialState
    switch (closeSiblings) {
        case `all`:
            initialState = 0
            break
        case `column`:
            initialState = {
                first: 0,
                second: 0
            }
            break
        default:
            initialState = []
    }
    const [currentlyOpen, setCurrentlyOpen] = useState(initialState)

    const notify_new_open = (item) => {
        let item_colum = item.split(`col_`)[1].split(`_`)[0]
        switch (closeSiblings) {
            case `all`:
                setCurrentlyOpen(currentlyOpen === item ? 0 : item)
                break
            case `column`:
                setCurrentlyOpen({
                    ...currentlyOpen,
                    [item_colum]: currentlyOpen[item_colum] === item ? 0 : item
                })
                break
            default:
                if (currentlyOpen.includes(item)) {
                    setCurrentlyOpen(currentlyOpen.filter(id => id !== item))
                } else {
                    setCurrentlyOpen([...currentlyOpen, item])
                }
        }
    }

    function is_item_open(item_id) {
        switch (closeSiblings) {
            case `all`:
                return currentlyOpen === item_id
            case `column`:
                return currentlyOpen[item_id.split(`col_`)[1].split(`_`)[0]] === item_id
            default:
                return currentlyOpen.includes(item_id)
        }
    }

    return (
        <>
            <div className={columns.firstClass}>
                {columns.first.map(item => {
                    return (
                        <Accordion
                            detailsClass={item.className}
                            key={item.id}
                            id={item.id}
                            summaryClass={item.summaryClass}
                            header={item.header}
                            headerClass={item.headerClass}
                            content={item.content}
                            contentClass={item.contentClass}
                            currentlyOpen={is_item_open(item.id)}
                            notify_parent={notify_new_open}
                            suppressHydrationWarning={true}
                            includeHr={false}
                        />
                    )
                })}
            </div>
            <div className={columns.secondClass}>
                {columns.second.map(item => {
                    return (
                        <Accordion
                            detailsClass={item.className}
                            key={item.id}
                            id={item.id}
                            summaryClass={item.summaryClass}
                            header={item.header}
                            headerClass={item.headerClass}
                            content={item.content}
                            contentClass={item.contentClass}
                            currentlyOpen={is_item_open(item.id)}
                            notify_parent={notify_new_open}
                            suppressHydrationWarning={true}
                            includeHr={false}
                        />
                    )
                })}
            </div>
        </>
    )
}
